import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { generateRandomAlphaNumeric } from "../../../Utils/alphaNumeric";
import logo from "../../../assets/illustrations/signal-AI.png"
import { useSelector } from 'react-redux';
import { postLogDetails } from "../../../Services/APIs/appDetails";

import "../signal.css"

const SignalAILandingPage = ({ params }) => {
    const { company } = params;
    const navigate = useNavigate();
    const storedUid = localStorage.getItem("usertpi")
    const initialId = storedUid ? JSON.parse(storedUid).usertpi : ''
    const [uid, setUid] = useState(initialId)
    const { images } = useSelector((state) => state.fullScan);

    useEffect(() => {
        if (!sessionStorage.getItem("reloaded")) {
            reload();
            return;
        }
        const generateInfo = () => {
            localStorage.clear()
            const randomString = generateRandomAlphaNumeric(2);
            const timestamp = Date.now().toString();
            const randomString2 = generateRandomAlphaNumeric(1)
            const unique = randomString + timestamp + randomString2
            localStorage.setItem("usertpi", JSON.stringify({ usertpi: unique }));
            localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: company }));
            setUid(unique)
            postLogDetails({ uid: unique, app: company, payLoad: `New user: ${unique}` })
        }

        if (!uid || images.length === 0) {
            generateInfo()
        } else {
            postLogDetails({ uid, app: company, payLoad: `Landing loaded - user: ${uid}` })
        }
    }, [])

    const reload = () => {
        sessionStorage.setItem("reloaded", "true")
        postLogDetails({ uid, app: company, payLoad: `Reloaded` })
        window.location.reload()
    }

    const moveToGuide = () => {
        postLogDetails({ uid, app: company, payLoad: `Get Started clicked` })
        navigate("/signalai_wohd/guide");
    }

    return (
        <div className="signal-ai-bg-image h-full w-full flex flex-col items-center justify-center text-signal-ai-primary">
            <img src={logo} alt="SignalAI Logo" className="w-3/5" />
            <div className=" bg-gradient-to-t from-slate-100 shadow-md to-transparent py-10 px-10 w-fit mx-auto rounded-lg">
                <h1 className=" text-[40px] font-bold text-left leading-10 text-signal-ai-blue">Oral Health <br /> Checkup</h1>
                <p className="text-left text-lg text-signal-ai-secondary mt-10 mb-7 font-medium whitespace-nowrap">အသုံးပြုလိုတဲ့ font ရွေးပေးပါ။</p>
                <div className="flex items-center justify-between gap-4">
                    <button className="px-4 py-2 text-lg w-1/2 bg-signal-ai-secondary text-white rounded" onClick={moveToGuide}>Unicode</button>
                    <button className="px-4 py-2 w-1/2 text-lg bg-signal-ai-secondary text-white rounded" onClick={moveToGuide}>Zawgyi</button>
                </div>
            </div>
            <p className="my-5 mx-12 text-signal-ai-blue">ကမ္ဘာ့သွားကျန်းမာရေးနေ့မှာမိမိနဲ့တစ်သက်လုံးအတူရှိနေမဲ့သွားတွေကိုSignal Aiနဲ့စစ်ဆေးလိုက်ရအောင်။</p>
        </div>
    )
}

export default SignalAILandingPage